import React from 'react';

type SaveInstructionsProps = {
  className?: string;
  isLocation?: boolean;
};

const SaveInstructions = ({
  className = 'flex items-center justify-center mt-4',
  isLocation = false,
}: SaveInstructionsProps) => {
  return (
    <div className={className}>
      <p className="text-center">
        Always click "Save" after making your changes / selections.
        <>
          <br />
          If an item no longer supports this{' '}
          {isLocation ? 'Location' : 'Enterprise'}, uncheck it here after
          zeroing it out on the next screen and click "Save" below.
        </>
      </p>
    </div>
  );
};

export default SaveInstructions;
